// Bridges the project-scoped auth token from React (ProjectProvider owns it)
// to the plain `dsmApi` module, which talks to the DSM backend directly. The
// DSM write endpoints require the PROJECT token (it carries x-hasura-project-id),
// not the subscription access token — so we can't read it from services/auth.

let projectToken: string | null = null;

export const setDsmProjectToken = (token: string | null) => {
  projectToken = token;
};

export const getDsmProjectToken = () => projectToken;
